// extracted by mini-css-extract-plugin
export default {"modalbackdrop":"NewModal_modalbackdrop__DSQ2v","modalcontent":"NewModal_modalcontent__yPc85"};